<template>
  <b-form-group
    label="Etiket"
    label-for="id_account_types"
  >
    <validation-provider
      #default="{ errors }"
      name="Etiket"
      rules="required"
    >
      <b-form-radio-group
        id="id_account_types"
        v-model="dataItem.id_account_types"
        :options="accountTypes"
        text-field="title"
        value-field="id"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormRadioGroup,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'DonationTypes',
  components: {
    BFormGroup,
    BFormRadioGroup,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['donationGroups/dataItem']
    },
    accountTypes() {
      return this.$store.getters['accountTypes/dataList']
    },
  },
  created() {
    localize('tr')
    this.getAccountTypes()
  },
  methods: {
    getAccountTypes() {
      this.$store.dispatch('accountTypes/getDataList', {
        select: [
          'account_types.id AS id',
          'account_types.title AS title',
        ],
      })
    },
  },
}
</script>
